import React, { Component } from 'react';

import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { REFUND_METHOD_CREDITS, REFUND_METHOD_DEFAULT, REFUND_METHOD_MANUAL } from '~/consts/refund';

import { withTenant } from '../hoc';

const NEUTRAL_RADIO_SX = {
  color: 'text.secondary',
  '&.Mui-checked': {
    color: 'text.primary',
  },
};

class RefundMethod extends Component {
  renderLatitudeMethods() {
    const { handleValueChange, refund_method } = this.props;
    return (
      <RadioGroup row name="refund_method" value={refund_method ?? ''} onChange={handleValueChange}>
        <FormControlLabel
          value={REFUND_METHOD_CREDITS}
          control={<Radio size="small" sx={NEUTRAL_RADIO_SX} />}
          label="Credits"
          sx={{ mr: 2.5 }}
        />
        <FormControlLabel
          value={REFUND_METHOD_MANUAL}
          control={<Radio size="small" sx={NEUTRAL_RADIO_SX} />}
          label="Latitude Manual Refund"
        />
      </RadioGroup>
    );
  }

  renderNormalMethods() {
    const { handleValueChange, refund_method, methods } = this.props;

    const NON_LE_CREDIT_BRANDS = ['zoomzoom'];
    return (
      <RadioGroup row name="refund_method" value={refund_method ?? ''} onChange={handleValueChange}>
        {methods.includes(REFUND_METHOD_DEFAULT) && (
          <FormControlLabel
            value={REFUND_METHOD_DEFAULT}
            control={<Radio size="small" sx={NEUTRAL_RADIO_SX} />}
            label="Default"
            sx={{ mr: 2.5 }}
          />
        )}
        {!NON_LE_CREDIT_BRANDS.includes(this.props.tenant.brand) && methods.includes(REFUND_METHOD_CREDITS) && (
          <FormControlLabel
            value={REFUND_METHOD_CREDITS}
            control={<Radio size="small" sx={NEUTRAL_RADIO_SX} />}
            label="Credits"
            sx={{ mr: 2.5 }}
          />
        )}
        {methods.includes(REFUND_METHOD_MANUAL) && (
          <FormControlLabel
            value={REFUND_METHOD_MANUAL}
            control={<Radio size="small" sx={NEUTRAL_RADIO_SX} />}
            label="Offline/Manual"
          />
        )}
      </RadioGroup>
    );
  }
  render() {
    const { hasLatitudePayment } = this.props;
    if (hasLatitudePayment === true) {
      return this.renderLatitudeMethods();
    }
    return this.renderNormalMethods();
  }
}

export default withTenant(RefundMethod);
